import { render, staticRenderFns } from "./ResultAnalysis.vue?vue&type=template&id=203b112a&"
import script from "./ResultAnalysis.vue?vue&type=script&lang=js&"
export * from "./ResultAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports